// extracted by mini-css-extract-plugin
export var tosLink = "_71-0";